// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueAxios from "vue-axios";
import { securedAxiosInstance, plainAxiosInstance } from "./backend/axios";
import Toasted from "vue-toasted";
import VCalendar from "v-calendar";
import ToggleButton from "vue-js-toggle-button";
import { store } from "./store/store";
import VModal from "vue-js-modal";
import VueTextareaAutosize from "vue-textarea-autosize";
import vSelect from "vue-select";
import Popover from "vue-js-popover";
import "./main.css";
import "./main.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

Vue.config.productionTip = false;

Vue.component("v-select", vSelect);
Vue.use(VueTextareaAutosize);
Vue.use(VCalendar, {
  screens: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
  }
});
Vue.use(Popover);
Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance
});

Vue.use(Toasted, {
  position: "top-center",
  duration: 5000,
  keepOnHover: true
});

Vue.use(ToggleButton);

Vue.use(VModal);
Vue.use(require("vue-moment"));
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  securedAxiosInstance,
  plainAxiosInstance,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js